import { useTranslation } from "react-i18next";

import { Button, Card, Col, Flex, Row, Space, Spin } from "antd";
import { Content } from "antd/es/layout/layout";
import { Info } from "components/elements";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { formatIdCard } from "utils/formatter/formatCommon";
import { ReactComponent as EyeHideIcon } from "../../../assets/icon/eyeClose.svg";
import { ReactComponent as EyeIcon } from "../../../assets/icon/eyeIcon.svg";
import { ReactComponent as EditIcon } from "../../../assets/images/edit.svg";
import EmployeeInfoGeneralForm from "./EmployeeInfoGeneralForm";

function EmployeeInfoGeneralInfoComponent({
  isEditing = false,
  generalInfo = [],
  raceOptions = [],
  initialValues = {},
  genderOptions = [],
  religionOptions = [],
  titleNameOptions = [],
  titleNameEnOptions = [],
  bloodGroupOptions = [],
  nationalityOptions = [],
  maritalStatusOptions = [],
  militaryStatusOptions = [],
  countryOptions = [],
  visaTypeOptions = [],
  onEdit = () => { },
  onSubmit = () => { },
  onCancel = () => { },
  ss = () => { },
  gift = () => { },
  dog = () => { },
  view = false,
  isVisible = false,
  handleToggleVisibility = () => { },
  isLoading = false,
  pageForm = "EMPLOYEE",
  permissions
}) {
  console.log("🚀 ~ permissions:", permissions)
  const { t, i18n } = useTranslation();
  const { roles } = useSelector((state) => state.company);
  // const { remainingLeave, employeeWorkInCount } = useSelector((state) => state.employee);
  // const language = i18n.language == 'en' ? "En" : ""
  const checkDisableVisible = () => {
    return permissions?.VISIBLE ? false : true
  }
  const checkDisableEdit = () => {
    return permissions?.UPDATE ? false : true
  }

  const colStyle = {
    xs: {
      flex: '100%',
    },
    sm: {
      flex: '100%',
    },
    md: {
      flex: '30%',
    },
    lg: {
      flex: '30%',
    },
    xl: {
      flex: '33%',
    }
  }

  const getName = (language) => {
    if (language === "TH") {
      const fullName = (generalInfo?.title?.name || "") + " " + (generalInfo?.name || "") + " " + (generalInfo?.surName || "");
      return fullName.trim() || "-";
    } else {
      const fullName = (generalInfo?.title?.nameEn || "") + " " + (generalInfo?.nameEn || "") + " " + (generalInfo?.surNameEn || "");
      return fullName.trim() || "-";
    }
  }

  const getBirthday = () => {
    if (isVisible) {
      return generalInfo?.dateOfBirth
        ? dayjs(generalInfo?.dateOfBirth).format("DD/MM/" + (i18n.language === 'en' ? "YYYY" : "BBBB"))
        : "-"
    } else {
      const mark = generalInfo?.dateOfBirthMark
      if (!mark) return "-"

      if (i18n.language === 'en') {
        return mark.replace(/\d+$/, (year) => {
          const parsed = parseInt(year)
          return isNaN(parsed) ? year : parsed - 543
        })
      }

      return mark
    }
  }

  const getAge = () => {
    let age
    if (isVisible) {
      if (generalInfo?.dateOfBirth) {
        const birth = dayjs(generalInfo?.dateOfBirth);
        const today = dayjs();

        const hasHadBirthday = today.isAfter(birth.add(today.year() - birth.year(), 'year'));

        age = hasHadBirthday
          ? today.year() - birth.year()
          : today.year() - birth.year() - 1;
      } else {
        <span>-</span>
      }
    } else {
      age = "xx"
    }
    return age
  }

  if (isEditing) {
    return (
      <EmployeeInfoGeneralForm
        raceOptions={raceOptions}
        initialValues={initialValues}
        religionOptions={religionOptions}
        genderOptions={genderOptions}
        titleNameOptions={titleNameOptions}
        titleNameEnOptions={titleNameEnOptions}
        bloodGroupOptions={bloodGroupOptions}
        nationalityOptions={nationalityOptions}
        maritalStatusOptions={maritalStatusOptions}
        militaryStatusOptions={militaryStatusOptions}
        countryOptions={countryOptions}
        visaTypeOptions={visaTypeOptions}
        onSubmit={onSubmit}
        onCancel={onCancel}
        ss={ss}
        gift={gift}
        dog={dog}
        isLoading={isLoading}
      />
    );
  }

  return (
    // <Row gutter={24}>
    //   <Col span={6}>
    //     <EmployeeProfileTab />
    //   </Col>

    //   <Col span={18}>
    //     <Flex style={{ marginBottom: 20 }}>
    //       <Card style={{
    //         width: "100%",
    //         border: "solid 1px #EAECF0",
    //         backgroundColor: "FCFCFC"
    //       }}>
    //         <Row>
    //           <Col span={19} style={{ display: "flex", flexDirection: "column", rowGap: "12px" }}>
    //             <Row>
    //               <span style={{ color: "#42526D" }}>{t("employee.leave_benefit_remain")}</span>
    //             </Row>
    //             <Row justify={"space-around"}>
    //               {remainingLeave?.map((leave, index) => (
    //                 <Col key={index} span={5} style={{ display: "flex", flexDirection: "column", rowGap: "10px" }}>
    //                   <Card style={{ borderRadius: "50%", border: "solid 1px #E4E7EC", width: "80px", height: "80px", textAlignLast: "center" }}>
    //                     <span style={{ color: "#42526D", fontSize: "20px", fontWeight: "bold" }}>{leave?.unlimited == "Y" ? "∞" : leave?.remainingLeaveDays}</span>
    //                   </Card>
    //                   <Flex vertical>
    //                     <span style={{ color: "#667085" }}>{leave?.["leaveTypeName" + language]}</span>
    //                     <span>{leave?.unlimited == "Y" ? t("unlimited") : leave?.totalLeaveDays + " " + t("unit.days")} </span>
    //                   </Flex>
    //                 </Col>
    //               ))}
    //             </Row>
    //           </Col>
    //           <Col span={1}>
    //             <Divider type="vertical" className={styles.customDivider} style={{ height: "100%" }} />
    //           </Col>
    //           <Col span={4} style={{ display: "flex", flexDirection: "column", rowGap: "20px", justifyContent: "center" }}>
    //             <Row>
    //               <Col span={12} style={{ display: "flex", flexDirection: "column" }}>
    //                 <span style={{ color: "#2CADE7", fontSize: "20px", fontWeight: "bold", textAlign: "center" }}>{employeeWorkInCount?.checkInEarly}</span>
    //                 <span style={{ color: "#667085", textAlign: "center" }}>{t("home.eary_come")}</span>
    //               </Col>
    //               <Col span={12} style={{ display: "flex", flexDirection: "column" }}>
    //                 <span style={{ color: "#2CADE7", fontSize: "20px", fontWeight: "bold", textAlign: "center" }}>{employeeWorkInCount?.checkInLate}</span>
    //                 <span style={{ color: "#667085", textAlign: "center" }}>{t("home.late")}</span>
    //               </Col>
    //             </Row>
    //             <Row>
    //               <Col span={12} style={{ display: "flex", flexDirection: "column" }}>
    //                 <span style={{ color: "#2CADE7", fontSize: "20px", fontWeight: "bold", textAlign: "center" }}>{employeeWorkInCount?.checkOutEarly}</span>
    //                 <span style={{ color: "#667085", textAlign: "center" }}>{t("home.early")}</span>
    //               </Col>
    //               <Col span={12} style={{ display: "flex", flexDirection: "column" }}>
    //                 <span style={{ color: "#2CADE7", fontSize: "20px", fontWeight: "bold", textAlign: "center" }}>{employeeWorkInCount?.checkOutLate}</span>
    //                 <span style={{ color: "#667085", textAlign: "center" }}>{t("home.back_late")}</span>
    //               </Col>
    //             </Row>

    //           </Col>
    //         </Row>
    //       </Card>
    //     </Flex>

    <Flex vertical>
      <Spin spinning={isLoading}>
        <Card style={{
          // margin: "10px",
          // padding: "20px",
          border: "solid 1px #EAECF0",
          backgroundColor: "FCFCFC",
          width: "100%"
        }}>
          {/* <Card style={{ backgroundColor: "red" }}>ggg</Card> */}
          <Space style={{ width: "100%" }} size={24} direction="vertical">
            {(roles.includes("ACCESS_DATA_SECURITY|EMPLOYEE|GENERAL_INFO") ||
              (view === false && roles.includes("UPDATE_EMPLOYEE|EMPLOYEE_INFO|GENERAL_INFO"))) && (
                <Row style={{ gap: "10px" }} justify="end">
                  {roles.includes("ACCESS_DATA_SECURITY|EMPLOYEE|GENERAL_INFO") && (
                    <Button style={{ width: "max-content", height: "40px", borderRadius: "8px", padding: "10px 16px" }}
                      icon={isVisible ? <EyeHideIcon /> : <EyeIcon />}
                      onClick={handleToggleVisibility}
                    // disabled={checkDisableVisible()}
                    />)}
                  {view === false && roles.includes("UPDATE_EMPLOYEE|EMPLOYEE_INFO|GENERAL_INFO") &&
                    <Button onClick={onEdit}
                      type="primary"
                      style={{ width: "max-content", height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)", padding: "8px 16px", color: permissions?.UPDATE === true ? "white" : null }}
                    // disabled={checkDisableEdit()}
                    >
                      <Flex align="center" justify="center" gap={8}>
                        <EditIcon />
                        {t("common.edit").toUpperCase()}
                      </Flex>
                    </Button>}
                </Row>
              )}

            <Row gutter={0}>
              <Content>
                <Flex vertical={true} style={{ gap: 16 }}>
                  <Row gutter={0} style={{ justifyContent: "space-around" }}>
                    <Col {...colStyle}  >
                      <Info label={t('employee.name-surname')} value={getName("TH")} />
                    </Col>
                    <Col {...colStyle}>
                      <Info label={t('employee.nickname-th')} value={generalInfo?.nickName || "-"} />
                    </Col>
                    <Col {...colStyle}>
                      <Info
                        label={t('identification-no-tax-id')}
                        value={formatIdCard(generalInfo?.employeeNationality === "D" ? generalInfo?.identificationNo : generalInfo?.taxId || "-")}
                      />
                    </Col>
                  </Row>
                  <Row gutter={0} style={{ justifyContent: "space-around" }}>
                    <Col {...colStyle}>
                      <Info label={t('employee.name-surname-en')} value={getName("EN")} />
                    </Col>
                    <Col  {...colStyle}>
                      <Info label={t('employeeInfo.nickname-en')} value={generalInfo?.nickNameEn || "-"} />
                    </Col>
                    <Col {...colStyle}>
                      <Info label={t('employee.gender')} value={i18n.language === 'en' ? generalInfo?.gender?.nameEn : generalInfo?.gender?.name} />
                    </Col>
                  </Row>
                  <Row gutter={0} style={{ justifyContent: "space-around" }}>
                    <Col {...colStyle}>
                      <Info
                        label={t('employee.date-of-birth')}
                        value={getBirthday()}
                      />
                    </Col>
                    <Col {...colStyle}>
                      <Info
                        label={t('employee.age-0')}
                        value={getAge()}
                      />
                    </Col>
                    <Col {...colStyle}>
                      <Info label={t('employee.race')} value={i18n.language === 'en' ? generalInfo?.race?.nameEn : generalInfo?.race?.name} />
                    </Col>

                  </Row>
                  <Row gutter={0} style={{ justifyContent: "space-around" }}>
                    <Col {...colStyle}>
                      <Info label={t('employee.nationality')} value={i18n.language === 'en' ? generalInfo?.nationality?.nameEn : generalInfo?.nationality?.name} />
                    </Col>
                    <Col {...colStyle}>
                      <Info label={t('employee.religion')} value={i18n.language === 'en' ? generalInfo?.religion?.nameEn : generalInfo?.religion?.name} />
                    </Col>
                    <Col {...colStyle}>
                      <Info
                        label={t('employee.marital-status')}
                        value={i18n.language === 'en' ? generalInfo?.maritalStatus?.nameEn : generalInfo?.maritalStatus?.name}
                      />
                    </Col>
                  </Row>
                  <Row gutter={0} style={{ justifyContent: "space-around" }}>
                    <Col {...colStyle}>
                      <Info
                        label={t('military-status')}
                        value={i18n.language === 'en' ? generalInfo?.militaryStatus?.nameEn : generalInfo?.militaryStatus?.name}
                      />
                    </Col>
                    <Col {...colStyle}>
                      <Info label={t('employee.weight')} value={generalInfo?.weight || "-"} />
                    </Col>
                    <Col {...colStyle}>
                      <Info label={t('height')} value={generalInfo?.height || "-"} />
                    </Col>
                  </Row>
                  <Row gutter={0} style={{ justifyContent: "space-around" }}>
                    <Col {...colStyle}>
                      <Info label={t('employee.blood-group')} value={i18n.language === 'en' ? generalInfo?.bloodGroup?.nameEn : generalInfo?.bloodGroup?.name} />
                    </Col>
                    <Col {...colStyle}>
                      <Info label={t('remark')} value={generalInfo?.remark || "-"} />
                    </Col>
                    <Col {...colStyle}></Col>
                  </Row>
                </Flex>
              </Content>
            </Row>
            {/* </div> */}
          </Space >
        </Card >
      </Spin>
    </Flex>
  );
}

export default EmployeeInfoGeneralInfoComponent;
